import apiRequest from "../api/apiRequest";
import { apiConfig } from "../config/apiConfig";
import { REGEX } from "../constants/regex";
import { StateHandler } from "../util/getStateFun";
import { startLoader, stopLoader } from "../util/loader";
import { LocateAddressBumper } from "../header/locateAddressBumper";
import { getBrandDetailsFromBrandJson, getCampaignName, storeBookingApiPayload,capitalizeString, getFranchiseDetails, getFranchiseWebLocationIdDetails, getFranchiseWebLocationId, insertAfterUrl, detectServicePageTypeByAssetPath, localizationHelper } from "../util/share";
import { cachedAPIWrapper, getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { apiCaching } from "../config/cachingConfig";
import { gtmCustomEventLeadFlow } from "../util/gtm-custom-event-lead-flow";
import { handleMissingData } from "../util/discovery";
import { ContactUsPayloadModel } from "../apiCaching/POST-Requests/interface/contact/contactInterface";
import { disclaimerHandleCheck } from "../util/disclaimerService";
import { modalVisibilityCheck } from "../util/modalVisibilityCheck";
import { DomainIdentifier } from "../util/domainService";
import { LocalizationIdentifier } from "../util/localizationService";
import { Modal } from "flowbite";
import { contactUsPostCallWrapper } from "../apiCaching/POST-Requests/apiContactCallWrapper";
import { BookingPayloadModel } from "../apiCaching/POST-Requests/interface/booking/bookingInterface";
import { bookingUsPostCallWrapper } from "../apiCaching/POST-Requests/apibookingCallWrapper";
import { getCountryCode } from "../location-search-map/getCountryCode";
import { localizationTagUpadation } from "../util/localizationTag";
import { validateEmail } from "../util/real-time-email-validation";
import { NearbyLocations } from "../util/nearbyLocations";
import { NearbyLocationsMiles, ComponentType } from "../util/nearbyLocationsMiles";
import { NblyBrandContactUs } from "../nbly-brand/nbly-brand-contactus";

interface LeadSourceArray {
    find(arg0: (source: LeadSource) => boolean): LeadSource | undefined;
}
declare global {
    interface Window {
        getFormFields?: Record<string, any>;
        isShortForm?: any
    }
}
interface LeadSource {
    syncGenericLeadSourceId: number;
    leadSourceName: string;
    isActive: boolean;
    referralTypeId: string;
    referralSourceId: any;
}
export class ResidentialForm {
    private nameInput: HTMLInputElement;
    private lastNameInput: HTMLInputElement;
    private emailInput: HTMLInputElement;
    private phoneInput: HTMLInputElement;
    private addressInput: HTMLInputElement;
    private fullAddressInput!: HTMLInputElement;
    private businessNameInput: HTMLInputElement;
    private submitButton: any;
    private privateSuggestedArray = [];
    private form: any;
    private isCAReminderModal: boolean = false;
    private readonly shortFormService: NodeListOf<HTMLElement>;
    private noteWithRequestBody: any;
    private serviceTypeID: number;
    private readonly shortFormLeadType: NodeListOf<HTMLElement>;
    controller: AbortController = new AbortController();
    private isServiceModifierNotSelected:boolean=false


    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            this.calculateShortFormCount();
            this.asideCardToMobile();
            this.initializeCommercialRadioCheck();
        });
        
        window.addEventListener('resize', this.asideCardToMobile);
        const containerData = document.querySelector('.aside-card.tabs-mobile');
        this.asideCardToMobile();
        const nameInputDesk = document.getElementById('req-name') as HTMLInputElement;
        const lastNameInputDesk = document.getElementById('req-lname') as HTMLInputElement;
        const nameInputMob = document.getElementById('req-name-mobile') as HTMLInputElement;
        const emailInputDesk = document.getElementById('req-email') as HTMLInputElement;
        const emailInputMob = document.getElementById('req-email-mobile') as HTMLInputElement;
        const phoneInputDesk = document.getElementById('req-phone') as HTMLInputElement;
        const phoneInputMob = document.getElementById('req-phone-mobile') as HTMLInputElement;
        const addressInputDesk = document.getElementById('req-address') as HTMLInputElement;
        addressInputDesk?.addEventListener('focusout', this.handleFocusOut.bind(this, 'req-address'));
        const addressInput1 = document.getElementById('short-form-req-address') as HTMLInputElement;
        addressInput1?.addEventListener('focusout', this.handleFocusOut.bind(this, 'short-form-req-address'));
        const addressInputMob = document.getElementById('req-address-mobile') as HTMLInputElement;
        this.shortFormService = document.querySelectorAll('[id*="short-form-service-reminder"]');
        this.nameInput = nameInputDesk ? nameInputDesk : nameInputMob;
        this.lastNameInput = lastNameInputDesk;
        this.emailInput = emailInputDesk ? emailInputDesk : emailInputMob;
        this.phoneInput = phoneInputDesk ? phoneInputDesk : phoneInputMob;
        this.addressInput = addressInputDesk ? addressInputDesk : addressInputMob;
        this.fullAddressInput = document.getElementById('req-full-address') as HTMLInputElement;
        const businessNameInputDesk = document.getElementById('sendB-name') as HTMLInputElement;
        const businessNameInputMob = document.getElementById('sendB-name-mobile') as HTMLInputElement;
        this.businessNameInput = businessNameInputDesk ? businessNameInputDesk : businessNameInputMob;
        this.submitButton = document.querySelectorAll('.residential-form .primary-btn');
        this.submitButton?.forEach((btn: any) => {
            btn.addEventListener('click', this.setAutoSuggested.bind(this))
        });
        this.serviceTypeID = Number.NaN;

    

        this.initializeInputNameRestriction();
        this.initializeInputLastNameRestriction();
        this.initializeInputBusinessNameValidation();
        this.initializeInputEmailValidation();
        this.initializeInputPhoneValidation();
        this.initializeInputZipCodeValidation();
        this.initializeInputFullAddressValidation();
        this.allRadioButtonsEventListener();
        this.initializeInputCommentValidation();
        this.initializePreferredContactValidation();
        this.shortFormService?.forEach((checkbox) => {
            checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
          });
        // Add event listener to each serviceType to handle the change
        this.shortFormLeadType = document.querySelectorAll('.short-lead-radio-wrap .radio-basic');
        this.shortFormLeadType?.forEach((radio) => {
            radio.addEventListener('change', (event)=>{
                this.handleRadioChange(event);
            })
    });
          const localisation = DomainIdentifier();
          const countryCode = getCountryCode();
          const localisedcountryCode = sessionStorage.getItem('countryCode');
        if (localisation == 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') {
            this.hideTermsPolicyForAllForms();
        }
    }

    hideTermsPolicyForAllForms() {
        // Get all .residential-form elements
        const forms = document.querySelectorAll('.residential-form');
        // Iterate all forms  
        forms.forEach(form => {
            // Check if there's a .short-form-req-new section inside the form
            const shortFormReqNew = form.querySelector('.short-form-req-new');
            const children = Array.from(form.children);
            if (shortFormReqNew) {
                const children = Array.from(shortFormReqNew.children);
                const termsPolicy = children.find(child => child.classList.contains('terms-policy-text'));
                if (termsPolicy) {
                    const termsPolicyElement = termsPolicy as HTMLElement;
                    termsPolicyElement.style.display = 'none'; // Hide for canada ZIP codes
                }
            } else {
                // to find .terms-policy-text child
                const termsPolicy = children.find(child => child.classList?.contains('terms-policy-text')) as HTMLElement;

                if (termsPolicy) {
                    termsPolicy.style.display = 'none'; // Hide for Canada ZIP codes
                }
            }
        });
    }

     getCountryByZip(zipCode: string): string {
        return !REGEX.sendCaPostalCode.test(zipCode) ? 'us' : 'ca';
    }

    toggleTermsPolicyDisplay(termsPolicy: HTMLElement, countryZip: string, zipCodeInput: any): void {
        const localisation = DomainIdentifier();
        const countryCode = getCountryCode(); 
        const localisedcountryCode = sessionStorage.getItem('countryCode');
        let zipCode = zipCodeInput?.value.trim();
        if ((countryZip === 'ca') && (localisation === 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') || (countryZip === 'ca') || ((zipCode === '') && (localisation == 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca'))) {
            termsPolicy.style.display = 'none'; // Hide for Canada ZIP codes & Canada local
        } 
        else if((countryZip === 'us' && zipCode !== '') && (localisation === 'ca' || countryCode === 'ca' || localisedcountryCode === 'ca') ) {
            termsPolicy.style.display = 'block';
        }
        else {
            termsPolicy.style.display = 'block'; // Show for US ZIP codes
        }
    }
    handleFocusOut(zipCodeId: string) {
        let zipCodeInput = document.getElementById(zipCodeId) as HTMLInputElement;  
        const countryZip = this.getCountryByZip(zipCodeInput?.value.trim() || '');
        const form = zipCodeInput.closest('.residential-form'); // Get closest form
        if (form) {
            const shortFormReqNew = form.querySelector('.short-form-req-new');
            const children = Array.from(form.children);
            if (shortFormReqNew) {
                // Find the immediate child with class .terms-policy-text inside .short-form-req-new
                const children = Array.from(shortFormReqNew.children);
                const termsPolicy = children.find(child => child.classList.contains('terms-policy-text'));
                if (termsPolicy) {
                    const termsPolicyElement = termsPolicy as HTMLElement;
                    this.toggleTermsPolicyDisplay(termsPolicyElement, countryZip, zipCodeInput);
                }
            } else {
                const termsPolicy = children.find(child => child.classList?.contains('terms-policy-text')) as HTMLElement;
                if (termsPolicy) {
                    this.toggleTermsPolicyDisplay(termsPolicy, countryZip, zipCodeInput);
                }
            }
        }
    }
    handleCheckboxChange() {
        const serviceReminderDivs = this.form?.querySelectorAll('.service-reminder-main');
        let errorID = null;

    // Check if any divs with the class 'service-reminder-main' are found
    if (serviceReminderDivs.length === 0) {
        console.log('Servcie Disclaimer not authored in CP');
        return; // Exit the function early if no divs are found
    }
        // Loop through each div
        serviceReminderDivs.forEach((div: HTMLElement) => {
            // Check if the div is visible (does not have the 'hidden' class)
            if (div && !div.classList.contains('hidden')) {
                // Find the checkbox input inside this div
                const checkbox = div.querySelector('input[type="checkbox"]');
                // Find the corresponding error message element
                const errorMsg = div.querySelector('.error-msg');

                // Check if the checkbox and errorMsg exist and if the checkbox is required
                if (checkbox && errorMsg && checkbox instanceof HTMLInputElement && checkbox.required) {
                    // Add event listener to handle checkbox state change
                    checkbox.addEventListener('change', () => {
                        // If the checkbox is checked, hide the error message
                        if (checkbox.checked) {
                            errorMsg.classList.add('hidden');
                        } else {
                            // If the checkbox is unchecked, show the error message
                            errorMsg.classList.remove('hidden');
                            errorID = errorMsg?.id;
                        }
                    });

                    // Initial check: if the checkbox is required and unchecked when the page loads
                    if (checkbox.required && !checkbox.checked) {
                        errorMsg.classList.remove('hidden');
                        errorID = errorMsg?.id;
                    }
                }
            }
        });
        return errorID;
      }

      handleRadioChange(e?: Event): string | null {
        // Find the closest form from the event target / the existing form reference
        const targetElement = e?.target as HTMLElement | undefined;
        const form = targetElement?.closest('form') || this.form;
        if (!form) return null;
        this.form = form; // update this.form in case if its undefined
    
        const radioButtons = form?.querySelectorAll('.short-lead-radio-wrap .radio-basic');
      
        let isChecked = false;
    
        let errorID = null;
        // Check if any radio button is checked rmeove the invalid field class for all
        radioButtons?.forEach((radio: any) => {
            const target = e?.target as HTMLInputElement;
            if (target?.classList?.contains('radio-basic')) {
                radio.classList.remove('invalid-field');
            }
    
            // Check if this radio is selected
            if (radio?.checked) {
                isChecked = true;
            }
        });
    
       // Find the error message div
       const serviceTypeDiv = this.form.querySelector('.short-lead-radio-wrap');
       if (!serviceTypeDiv) {
           console.log('Service Type not authored in CP');
           return null; // Exit if the service reminder div doesn't exist
       }

       const errorMsg = serviceTypeDiv.querySelector('.error-msg');
    
        if (errorMsg) {
            if (!isChecked && serviceTypeDiv.hasAttribute('required')) {
                // If no radio button is selected, show the error message
                errorMsg.classList.remove('hidden');
              errorID = errorMsg?.id;
            } else {
                // If a radio button is selected, hide the error message
                errorMsg.classList.add('hidden');
                errorID = errorMsg?.id;
            }
        }
    
        return errorID;
    }
    
    allRadioButtonsEventListener() {
        const labels = document.querySelectorAll('.req-call-btn');
        labels.forEach(label => {
            label.addEventListener('click', (event: any) => {
                const label = event.target.closest('.req-call-btn');
                const radio = label.closest('.req-call-tablist').querySelector('.req-call-radio');
                if (radio) {
                    radio.checked = true;
                }
            });
        });
    }

    setRadioChecked(serviceType: string): void {
        const savedServicePageType = sessionStorage.getItem('serviceType');
        if(!savedServicePageType) return;
        if (savedServicePageType !== serviceType) return;

        const radioBtns = document.querySelectorAll(`input[type="radio"][value*="${serviceType}"]`);

        for (const radioBtn of radioBtns) {
            if (radioBtn) {
                (radioBtn as HTMLInputElement).checked = true;
            }
        }   
    }


    initializeCommercialRadioCheck(): void {
        // Initialize service page type detection from assetPath
        detectServicePageTypeByAssetPath().then((serviceType) => {
            if (serviceType) {
                this.setRadioChecked('commercial');
            }
        });
    }

    private getShouldRedirectToLeadFlow(): boolean {
        return this.form?.querySelector('.redirect_lead_flow')?.value === "true";
    }

    private initializeInputNameRestriction(): void {
        const inputs = document.querySelectorAll('input.short-form-req-name,#req-name');
        inputs.forEach(input => {
            input.addEventListener('input', this.errorOnName.bind(this));
        });
    }
    private initializeInputLastNameRestriction(): void {
        const inputs = document.querySelectorAll('input.short-form-req-lname,#req-lname');
        inputs.forEach(input => {
            input.addEventListener('input', this.errorOnLastName.bind(this));
        });
    }

    private initializeInputBusinessNameValidation(): void {
        const inputs = document.querySelectorAll('input.short-form-sendB-name,#sendB-name');
        inputs.forEach(input => {
            input.addEventListener('input', this.errorOnBusinessName.bind(this));
        });
    }

    isShowRealtimeEmailValidationError(isShow: boolean,parentNode: HTMLElement | null){
        if(!parentNode) return;
        const errorMessage = parentNode.querySelector('.realtime-email-validation-error-message')
        if(!errorMessage) return;
        if(errorMessage.classList.contains('hidden') && isShow) errorMessage.classList.remove('hidden');
        if(!errorMessage.classList.contains('hidden') && !isShow) errorMessage.classList.add('hidden');
    }

    public initializeInputEmailValidation(): void {
        const inputs = document.querySelectorAll('input.short-form-req-email,#req-email');
        inputs.forEach(input => {
            input.addEventListener('input', this.emailError.bind(this));
            input.addEventListener('blur', (event) => {
                const emailInput = event.target as HTMLInputElement;
                const conceptCodeElement = document.getElementById('conceptCode') as HTMLInputElement;
                const conceptCode = conceptCodeElement ? conceptCodeElement.value : '';
                const params = {
                    value: emailInput.value,
                    signal: this.controller.signal,
                    conceptCode,
                };
                const parentNode = emailInput.parentNode as HTMLElement;
                const disableDefaultEmailErrorMessage = () => {
                    if(!parentNode) return;
                    const defaultError = parentNode.querySelector('.error-msg');
                    if(defaultError){
                        if(!defaultError.classList.contains('hidden')){
                            defaultError.classList.add('hidden');
                        }
                    }
                }
                validateEmail(params).then(result => {
                    if (result === 'EmptyField' || result === 'RegexFailed') return;
                    if(result === 'EmailValidationPassed' || result === 'SendGridFailed') {
                        this.isShowRealtimeEmailValidationError(false, parentNode);
                        return;
                    }
                    this.isShowRealtimeEmailValidationError(true, parentNode)
                    disableDefaultEmailErrorMessage()
                    input.setAttribute('data-validation-result', 'email-validated');
                }).catch(() => {
                    if(emailInput.parentNode){
                        this.isShowRealtimeEmailValidationError(true, parentNode)
                        disableDefaultEmailErrorMessage()
                    }
                    input.setAttribute('data-validation-result', 'email-validated');
                });
            });
        });
    }

    private initializeInputPhoneValidation(): void {
        const inputs = document.querySelectorAll('input.short-form-req-phone,#req-phone');
        inputs.forEach(input => {
            input.addEventListener('input', this.handleMobileInput.bind(this));
        });
    }
    private initializeInputZipCodeValidation(): void {
        const inputs = document.querySelectorAll('input.short-form-req-address,#req-address');
        inputs.forEach(input => {
            input.addEventListener('input', this.zipCodeError.bind(this));
        });
    }

    private initializeInputFullAddressValidation(): void {
        document.addEventListener('input', (event) => {
            const target = event.target as HTMLInputElement;
            // Check if the target matches our full address input selectors
            if (target.matches('#req-full-address, input#short-form-req-full-address')) {
                this.fullAddressError(event);
            }
        });
    }

    private initializeInputCommentValidation(): void {
        const inputs = document.getElementById('short-form-req-comment');
        inputs?.addEventListener('input', this.errorOnComment.bind(this));

    }

    private initializePreferredContactValidation(): void {
        const inputs = document.querySelectorAll('input[id*="short-form-req-pref"]');
        inputs.forEach(input => {
            input.addEventListener('input', this.prefMethodError.bind(this));
        });
    }

    public scrollToThankYouSection(form:any=null) {
        if (window.innerWidth <= 768) {
            let targetScrollElement = document.querySelector('.hero-review') as HTMLElement;
            const activeForm = form ?? this.form;
            if (targetScrollElement) {
                let OffSetTop = targetScrollElement?.offsetTop;
                window.scrollTo({
                    top: OffSetTop,
                    behavior: 'smooth'
                })
            }else{
                activeForm?.closest('.short-form-component')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    }

    errorOnComment(event: any) {
        const commentEle = event.target;
        this.form = event.target.closest('form');
        if (commentEle.value !== '' && !REGEX.matchAny.test(commentEle.value)) {
            const getErrMsg = (this.form.querySelector(`#${commentEle?.id}-error-msg`) as HTMLElement)?.textContent;
            const fieldError: any = this.form.querySelector(`#${commentEle?.id}-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg || 'Invalid comment.'

            }
        }
        else {
            this.hideError(commentEle?.id)
        }

    }

    prefMethodError(event: any) {
        const ele = event.target;
        this.form = event.target.closest('form');
        const inputs = document.querySelectorAll('input[id*="short-form-req-pref"]');
        const arrChecked: boolean[] = [];
        inputs.forEach((input: any) => {
            arrChecked.push(input?.checked as boolean);
        });
        const validOutput = arrChecked.some(function (a) {
            return a;
        });
        if (validOutput) {
            this.hidePrefError('shortform_preferred-contact-error-msg');
        }
        else {
            this.addPrefError('shortform_preferred-contact-error-msg');
        }

    }

    public handleMobileInput(e: any): void {
        const phoneInput = e.target;
        this.form = e.target.closest('form');
        e.preventDefault();
        const reg = REGEX.mobileNumberRegex;
        const val = phoneInput?.value;
        const x = val?.replace(/\D/g, '').match(reg);
        const formattedVal = x ? `(${x[1]}) ${x[2]}${x[3] ? '-' + x[3] : ''}` : '';
        // Save caret position
        const start = phoneInput.selectionStart ?? 0;
        const oldFormatted = val;
        if (phoneInput?.value != '' && phoneInput?.value.length < 14 && formattedVal.length < 14) {
            const getErrMsg = (this.form.querySelector(`#${phoneInput?.id}-error-msg`) as HTMLElement)?.textContent;
            const fieldError: any = this.form.querySelector(`#${phoneInput?.id}-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg || 'Invalid phone format.'

            }
            else {
                const field: any = phoneInput;
                if (field && field.parentNode) {
                    const errorMessage = getErrMsg || 'Invalid phone format.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }
        }
        else {
            this.hideError(phoneInput?.id)
        }

        if (x) {
            phoneInput!.value = !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? '-' + x[3] : ''}`;
            // Calculate new caret position
            if(phoneInput) {
                const positionDiff = phoneInput?.value ? phoneInput.value.length - oldFormatted.length : 0;
                const newCaretPos = start + positionDiff;
                phoneInput.setSelectionRange(phoneInput.selectionStart, newCaretPos);
            }
        }

    }
    errorOnName(event: any) {
        const nameInput = event.target;
        this.form = event.target.closest('form');
        if (nameInput.value !== '' && !REGEX.sendName.test(nameInput.value)) {
            const getErrMsg = (this.form.querySelector(`#${nameInput?.id}-error-msg`) as HTMLElement)?.textContent;
            const fieldError: any = this.form.querySelector(`#${nameInput?.id}-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg || 'Invalid name format.'

            }
            else {
                const field: any = nameInput;
                if (field && field.parentNode) {
                    const errorMessage = getErrMsg || 'Invalid name format.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }
        }
        else {
            this.hideError(nameInput?.id)
        }

    }
    errorOnLastName(event: any) {
        const lastNameInput = event.target;
        this.form = event.target.closest('form');
        if (lastNameInput.value !== '' && !REGEX.sendName.test(lastNameInput.value)) {
            const getErrMsg = (this.form.querySelector(`#${lastNameInput?.id}-error-msg`) as HTMLElement)?.textContent;
            const fieldError: any = this.form.querySelector(`#${lastNameInput?.id}-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg || 'Invalid last name format.'

            }
            else {
                const field: any = lastNameInput;
                if (field?.parentNode) {
                    const errorMessage = getErrMsg || 'Invalid last name format.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }
        }
        else {
            this.hideError(lastNameInput?.id)
        }

    }

    errorOnBusinessName(event: any) {
        const businessNameInput = event.target;
        this.form = event.target.closest('form');
        if (businessNameInput.value !== '' && !REGEX.matchAny.test(businessNameInput.value)) {
            const getErrMsg = (this.form.querySelector(`#${businessNameInput?.id}-error-msg`) as HTMLElement)?.textContent;
            const fieldError: any = this.form.querySelector(`#${businessNameInput?.id}-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg || 'Invalid business name format.'

            }
            else {
                const field: any = businessNameInput;
                if (field?.parentNode) {
                    const errorMessage = getErrMsg || 'Invalid business name format.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }
        }
        else {
            this.hideError(businessNameInput?.id)
        }

    }

    emailError(event: any) {
        const emailInput = event.target;
        const emailParentNode = emailInput.parentNode;
        this.form = event.target.closest('form');
        if(emailParentNode){
            this.isShowRealtimeEmailValidationError(false, emailParentNode)
            if(emailInput.hasAttribute('data-validation-result')){
                emailInput.removeAttribute('data-validation-result');
            }
        }
        if (emailInput.value != '' && !REGEX.sendEmail.test(emailInput.value)) {
            const emailElement = this.form.querySelector(`#${emailInput?.id}-error-msg`) as HTMLElement 
            const getErrMsg = emailElement?.textContent;
            const fieldError: any = this.form.querySelector(`#${emailInput?.id}-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg || 'Invalid email address, please try again.'
            }
            else {
                const field: any = emailInput;
                if (field && field.parentNode) {
                    const errorMessage = getErrMsg || 'Invalid email address, please try again.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }


        }
        else {

            this.hideError(emailInput?.id)
        }

    }

    zipCodeError(event: any) {
        const addressInput = event.target;
        this.form = event.target.closest('form');
        if ((addressInput?.value != '' && !REGEX.sendZip.test(addressInput?.value.trim())) || addressInput?.value == '00000') {
            const getErrMsg = (this.form.querySelector(`#${addressInput?.id}-error-msg`) as HTMLElement)?.textContent;
            const fieldError: any = this.form.querySelector(`#${addressInput?.id}-error-msg`);
            if (fieldError) {
                fieldError.classList.remove('hidden')
                fieldError.innerHTML = getErrMsg || 'Invalid zip code format.'
            }
            else {
                const field: any = addressInput;
                if (field && field.parentNode) {
                    const errorMessage = getErrMsg || 'Invalid zip code format.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }
        }
        else {
            this.hideError(addressInput?.id)
        }

    }

    fullAddressError(event: any) {
        const fullAddressInput = event.target;
        this.form = event.target.closest('form');

        const shouldRedirectToLeadFlow = this.getShouldRedirectToLeadFlow();
        
        if (shouldRedirectToLeadFlow && fullAddressInput?.value != '' && !REGEX.sendAddress2.test(fullAddressInput?.value)) {
            const errorSelector = this.form.querySelector(`#${fullAddressInput?.id}-error-msg`) as HTMLElement;
            const getErrMsg = errorSelector?.textContent;
            if (errorSelector) {
                errorSelector.classList.remove('hidden')
                errorSelector.innerHTML = getErrMsg || 'Invalid address format.'
            }
            else {
                const field: any = fullAddressInput;
                if (field?.parentNode) {
                    const errorMessage = getErrMsg || 'Invalid address format.';
                    const errorElement = document.createElement('span');
                    errorElement.className = 'error-msg';
                    errorElement.id = `${field.id}-error-msg`;
                    errorElement.textContent = errorMessage;
                    field.classList.add("invalid-field");
                    field.parentNode.appendChild(errorElement);
                }
            }
        }
        else {
            this.hideError(fullAddressInput?.id)
        }
    }

    hideError(id: any) {
        const field: any = this.form.querySelector(`#${id}`);
        const fieldError: any = this.form.querySelector(`#${id}-error-msg`);
        fieldError?.classList.add('hidden')
        field?.classList.remove('invalid-field');
    }

    hidePrefError(id: any) {
        const field: any = this.form.querySelector(`#${id}`);
        field?.classList.add('hidden')
        field?.classList.remove('invalid-field');
    }
    addPrefError(id: any) {
        const field: any = this.form.querySelector(`#${id}`);
        field?.classList.remove('hidden')
        field?.classList.add('invalid-field');
    }

    private getCheckedPreferedComunnication = () => {

        const checkedCheckboxes = this.form?.querySelectorAll('input[type="checkbox"].checkbox-basic:checked');
        let checkboxString = '';
        checkedCheckboxes?.forEach((checkbox: any, index: any) => {
            const preferredCommunication = checkbox.value;
            checkboxString += capitalizeString(preferredCommunication as any);
            if (index < checkedCheckboxes.length - 1) {
                checkboxString += ',';
            }
        });

        return checkboxString;

    };

    private getFormFields(): any {

    let residentialDesk = (this.form?.closest('.tabs-wrapper')?.querySelectorAll('input[name^="short-request-call-"]') as NodeListOf<HTMLInputElement>);
    let serviceModifierText = ''; 
        const filteredServiceModifier = Array.from(residentialDesk)?.filter(x => x.checked);
        const defaultCustomerType = (this.form?.closest('.tabs-wrapper')?.querySelector('#defaultCustomerType') as HTMLInputElement)?.value;

        if (filteredServiceModifier?.length === 0 && !this.isServiceModifierNotSelected) {
            const filteredServiceModifierNotSelected = Array.from(residentialDesk)?.filter((x)=>x?.value?.toLowerCase()?.includes(defaultCustomerType?.toLowerCase() ?? "residential"));
            if(filteredServiceModifierNotSelected.length > 0){
                filteredServiceModifier.push(filteredServiceModifierNotSelected[0]);
                this.isServiceModifierNotSelected = true;
            }
        }

        const requestType: string | undefined = (filteredServiceModifier[0]?.parentElement?.querySelector('.lead-service-typeId') as HTMLSelectElement)?.value ?? (filteredServiceModifier[0]?.parentElement?.querySelector('.short-lead-service-typeId') as HTMLSelectElement)?.value;
        if(requestType){
            this.serviceTypeID = Number.parseInt(requestType);
        }

        const getServiceModifier = (filteredServiceModifier:any,serviceText:string): string => {
            if (filteredServiceModifier.length > 0) {
                let serviceTextInput = filteredServiceModifier[0]?.parentElement.querySelector(serviceText)?.value;                
                serviceModifierText =  serviceTextInput?.replace(/-/g, " ") ?? '';                 
                // If radio value is empty, fetch from label for return value
                let radioValue = filteredServiceModifier[0]?.value;
                if (!radioValue || radioValue.trim() === '') {
                    const radioId = filteredServiceModifier[0]?.id;
                    if (radioId) {
                        const label = filteredServiceModifier[0]?.parentElement?.querySelector(`label[for="${radioId}"]`) ||
                                        filteredServiceModifier[0]?.parentElement?.querySelector(`label[for="short-form-${radioId}"]`);
                        if (label) {
                            radioValue = label.textContent?.trim() || '';
                        }
                    }
                }
                return capitalizeString(radioValue?.replaceAll("-", " "));
            }
            return defaultCustomerType ? capitalizeString(defaultCustomerType) : "Residential";
        };

        let serviceModilfier = getServiceModifier(filteredServiceModifier,'input[name^="lead-service-text-"]') || "Residential";
        const isShortForm = this.form?.closest('.short-form-component');
        const commentsEle = this.form.querySelector("#short-form-req-comment") as HTMLInputElement;
        let getCheckedPreferedComunnication = this.getCheckedPreferedComunnication();

        if (isShortForm) {
            this.nameInput = this.form.querySelector('#short-form-req-name');
            this.lastNameInput = this.form.querySelector('#short-form-req-lname');
            this.businessNameInput = this.form.querySelector('#short-form-sendB-name') || this.form.querySelector('#sendB-name');
            this.emailInput = this.form.querySelector('#short-form-req-email');
            this.phoneInput = this.form.querySelector('#short-form-req-phone');
            this.addressInput = this.form.querySelector('#short-form-req-address');
            this.fullAddressInput = this.form.querySelector('#short-form-req-full-address');
            const isShortServiceModifier = (isShortForm.querySelectorAll('input[name^="short-request-call"]') as NodeListOf<HTMLInputElement>);
            const filteredShortServiceModifier = Array.from(isShortServiceModifier)?.filter(x => x.checked);
            serviceModilfier = getServiceModifier(filteredShortServiceModifier,'input[name^="short-lead-service-text-"]') || "Residential";
        }
        else {
            this.nameInput = this.form.querySelector('#req-name');
            this.lastNameInput = this.form.querySelector('#req-lname');
            this.businessNameInput = this.form.querySelector('#sendB-name');
            this.emailInput = this.form.querySelector('#req-email');
            this.phoneInput = this.form.querySelector('#req-phone');
            this.addressInput = this.form.querySelector('#req-address');
            this.fullAddressInput = this.form.querySelector('#req-full-address');
        }

        let leadServiceId = '';
        if (filteredServiceModifier.length > 0) {
            const selectedRadio = filteredServiceModifier[0];
            const leadServiceIdField = selectedRadio?.parentElement?.querySelector(`.lead-service-id`);
            if (leadServiceIdField && (leadServiceIdField as HTMLInputElement)?.value) {
                leadServiceId = (leadServiceIdField as HTMLInputElement)?.value;
            }
        }

        const fields :any = {
            nameInput: this.nameInput,
            lastNameInput: this.lastNameInput,
            businessNameInput: this.businessNameInput,
            emailInput: this.emailInput,
            phoneInput: this.phoneInput,
            addressInput: this.addressInput,
            isResidential: serviceModilfier,
            comments: commentsEle?.value || '',
            preferCommunication: getCheckedPreferedComunnication || '',
            serviceText	: serviceModifierText,
            fullAddressInput: this.fullAddressInput
        };
        if (leadServiceId) {
            fields.leadServiceId = leadServiceId; // Include service-id if present
        }
        if (!Number.isNaN(this.serviceTypeID)) {
            fields.serviceTypeID = this.serviceTypeID;
        }

        return fields;
    }


    private validateInputs(): boolean {

        const formFields = this.getFormFields();
        window.getFormFields = formFields;
        this.form?.querySelectorAll('.invalid-field').forEach((e: any) => e.classList.remove('invalid-field'));
        const errors: any = {};

        if (formFields.nameInput) {
            if (formFields.nameInput?.value === '') {
                errors[formFields.nameInput?.id] = '';
            } else if (!REGEX.sendName.test(formFields.nameInput?.value)) {
                errors[formFields.nameInput?.id] = 'Invalid  name format.';
            }
        }

        if (formFields.lastNameInput) {
            if (formFields.lastNameInput?.value === '') {
                errors[formFields.lastNameInput?.id] = '';
            } else if (!REGEX.sendName.test(formFields.lastNameInput?.value)) {
                errors[formFields.lastNameInput?.id] = 'Invalid last name format.';
            }
        }

        if (formFields.businessNameInput) {
            if (formFields.businessNameInput?.value === '') {
                errors[formFields.businessNameInput?.id] = 'Invalid business name format.';
            }
        }

        if (formFields.phoneInput) {
            if (formFields.phoneInput?.value === '') {
                errors[formFields.phoneInput.id] = '';
            }
            else if (formFields.phoneInput?.value?.length < 14) {
                errors[formFields.phoneInput.id] = 'Invalid phone format.';
            }
        }

        if (formFields.addressInput) {
            if (formFields.addressInput?.value === '') {
                errors[formFields.addressInput?.id] = '';
            }
            else if (!REGEX.sendZip.test(formFields.addressInput?.value?.trim()) || this.addressInput?.value == '00000') {
                errors[formFields.addressInput?.id] = 'Invalid zip code format.';
            }
        }

        if(formFields.fullAddressInput){
            if (formFields.fullAddressInput?.value === '') {
                errors[formFields.fullAddressInput?.id] = '';
            }
            else {
                const shouldRedirectToLeadFlow = this.getShouldRedirectToLeadFlow();
                if (shouldRedirectToLeadFlow && !REGEX.sendAddress2.test(formFields.fullAddressInput?.value)) {
                    errors[formFields.fullAddressInput?.id] = 'Invalid address format.';
                }
            }
        }

        if (formFields.emailInput) {
            if (formFields.emailInput?.value === '') {
                errors[formFields.emailInput?.id] = '';
            } else if (!REGEX.sendEmail.test(formFields.emailInput?.value)) {
                errors[formFields.emailInput?.id] = 'Invalid email address, please try again.';
            }
        }

        const commentsEle = this.form.querySelector("#short-form-req-comment") as HTMLInputElement;
        if (commentsEle?.required && formFields.comments === '') {
            errors[commentsEle?.id] = '';
        }
        const labelElement = this.form.querySelector("#short-form-req-pref-email,#short-form-req-pref-phone,short-form-req-pref-text")?.closest('.input-label-wrap')?.querySelector('.label-basic');
        let isPreferCommunicationRequired = false;
        if (labelElement) {
            isPreferCommunicationRequired = labelElement.hasAttribute('required');
        }
        if (isPreferCommunicationRequired && formFields.preferCommunication === '') {
            errors['shortform_preferred-contact'] = '';
        }
        const errorIdChekboxSpan = this.handleCheckboxChange();
        if(errorIdChekboxSpan){
            errors[errorIdChekboxSpan] = '';
        }
        const servicetypeError = this.handleRadioChange();
        const serviceTypeDiv = this.form.querySelector('.short-lead-radio-wrap');
        const errorMsg = serviceTypeDiv?.querySelector('.error-msg');
        if (servicetypeError && serviceTypeDiv?.hasAttribute('required') && !errorMsg?.classList?.contains('hidden')) {
            // Only set errors if the field is required and no radio button is selected
            const cleanedServiceTypeError = servicetypeError.replace('-error-msg', '');
            errors[cleanedServiceTypeError] = '';
        }

        let self = this;
        Object.keys(errors).forEach((fieldId, index) => {
            let field: any = self.form.querySelector(`#${fieldId}`);
            if(fieldId === 'short-lead-service-type') {
                field = self.form.querySelector(`.${fieldId}`);
            }
            const fieldError: any = self.form.querySelector(`#${fieldId}-error-msg`);
            if (fieldId === 'shortform_preferred-contact') {
                if (fieldError?.classList.contains('hidden'))
                    fieldError.classList.remove('hidden')
            }
            if (field && field.parentNode) {
                const errorMessage = errors[fieldId];
                const errorElement = document.createElement('span');
                errorElement.className = 'error-msg';
                errorElement.id = `${fieldId}-error-msg`;
                errorElement.textContent = errorMessage;
                field.classList.add("invalid-field");
                if (fieldError && fieldError.classList.contains('hidden'))
                    fieldError.classList.remove('hidden')
            }
            if (index == 0 && field) {
                field.focus()
            }
        });
        return Object.keys(errors).length === 0;
    }

    getAddressValue(formFields: any, defaultValue: string): string {
        if (formFields?.fullAddressInput?.value) {
          return formFields.fullAddressInput.value;
        }
        return defaultValue;
      }

    private async handleSubmit(event: any, data: any, zipcodeInput: any): Promise<any> {
        event.preventDefault();
        const formFields = window.getFormFields ? window.getFormFields : this.getFormFields();
        this.form = window.isShortForm ? window.isShortForm : this.form;
        const campaignName = getCampaignName();
        const addressZip: any = zipcodeInput;
        let host = window.location.hostname.toLowerCase();
        let IsTest;
        if (host.includes('nblysbx') || host.includes('nblydev') || host.includes('nblytest')) {
            IsTest = true;
        } else {
            IsTest = false;
        }
        const id: any = data?.franchiseWebLocationId ?? undefined;
        const franchiseId: any = data?.franchiseId ?? undefined;
        const conceptId = (document.getElementById('conceptId') as HTMLInputElement)?.value;
        const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
        const email = formFields.emailInput
        if(!(email as HTMLInputElement).getAttribute('data-validation-result')){
            const params = {
                value: email.value,
                signal: this.controller.signal,
                conceptCode,
                historyCount: 5,
            };
            await validateEmail(params);
        }
        const defaultCustomerType = (document.getElementById('defaultCustomerType') as HTMLInputElement)?.value;
        const url = window.location.href;
        let vendorId: any;
        let vendorName: any;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode);
        if (brandData) {
            vendorId = brandData.vendorId;
            vendorName = brandData.vendorName;
        }

        const lastName = formFields.lastNameInput?.value ?? '';
        const businessName = formFields.businessNameInput?.value ?? '';
        const emailOptOut = brandData?.enable_emailOptOut;
        const defaultLeadSourceId = brandData?.default_leadSourceID || 0;
        const isShortForm = this.form?.closest('.short-form-component');
        let comments:string ="";
        // Send a authored text as part note or comment in booking API & it is appicable for short lead Body component form only
        if(brandData?.send_shortleadform_comments && isShortForm) {
            comments = brandData?.send_shortleadform_comments;
        }

        // Send a authored text as part note or comment in booking API & it is appicable for short lead form only
        if(brandData?.send_leadform_comments && !isShortForm) {
            if(comments) {
                comments += ", ";
            }
            comments += brandData?.send_leadform_comments;
        }

        if(formFields?.comments) {
            if(comments){
                comments += ", ";
            }
            comments += formFields.comments + ' ';
        }
        comments += `${comments ? ', ' : ''}Short Form Submit ID: 5h0r7`;

        const requestBody: BookingPayloadModel = {
            isLocalized: true,
            firstName: formFields.nameInput?.value.split(' ')[0] ? formFields.nameInput?.value.split(' ')[0] : '',
            lastName: formFields.nameInput?.value.split(' ')[1] ? formFields.nameInput?.value.split(' ')[1] : ' ',
            zipCode: addressZip?.address?.postalCode.trim(),
            postalCode: addressZip?.address?.postalCode.trim(),
            email: formFields.emailInput?.value,
            state: data?.state || addressZip?.address?.state,
            city: data?.city || addressZip?.address?.city,
            phone: formFields.phoneInput?.value,
            address: this.getAddressValue(formFields, "No address collected"),
            address2: '',
            comments: comments,
            note: comments,
            signUpForUpdates: false,
            conceptId: Number(conceptId),
            conceptCode: conceptCode,
            leadSource: "WEB",
            leadOrigin: "WEB",
            phoneType: 'true',
            isLeadOnly: true,
            isTest: IsTest,
            scheduleID: "",
            campaignName: campaignName,
            callType: "WEB",
            conceptCalledId: Number(conceptId),
            isEstimate: false,
            emailOptOut: emailOptOut,
            vendorId: Number(vendorId),
            vendorName: vendorName,
            currentPage: url,
            customerType: formFields.isResidential,
            preferredCommunicationType: formFields?.preferCommunication || 'Email,Phone',
            leadSourceId: defaultLeadSourceId,
            webLocationId: 0,
            licenseNumber: data?.licenseNumber,
        };

        if (!Number.isNaN(this.serviceTypeID)) {
            requestBody.serviceTypeID = this.serviceTypeID;
        }

        if (id) { 
            requestBody.webLocationId = id;
            requestBody.franchiseId = franchiseId;

            const dbaName = (document.getElementById('dbaName') as HTMLInputElement)?.value ?? localStorage.getItem('dbaName');

            if (dbaName && brandData?.send_shortform_lead_bookingapi) {
                const zipCode: any = sessionStorage.getItem('sAddressParam');
                const webId = (document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem('weblocationId');
                if (zipCode) {
                    let franchiseIdDetails = await getFranchiseWebLocationId(zipCode) as any
                    requestBody.webLocationId = Number(webId ?? id);
                    requestBody.franchiseId = franchiseIdDetails ? franchiseIdDetails?.franchiseId : null;
                } else if (webId) {
                    requestBody.webLocationId = Number(webId);
                    const apiUrl = apiConfig.FranchisePOSLookup + webId;
                    try {
                        let franchiseIdPOSDetails = await getCachedAPIResponse(apiUrl, apiCaching.POSSystemLookup);
                        if (franchiseIdPOSDetails.length > 0) {
                            requestBody.franchiseId = franchiseIdPOSDetails[0]?.franchiseId ? franchiseIdPOSDetails[0]?.franchiseId : null;
                        }
                    }
                    catch {
                        console.error("Error fetching FranchisePOSLookup in Residential Forms")
                    }
                }
            }
        }

        if (lastName) {
            requestBody.lastName = lastName;
            requestBody.firstName = formFields.nameInput?.value ?? '';
        }

        try {
            if (conceptCode?.toLocaleLowerCase() === 'dvw' && franchiseId) {
                const dynamic_url = `${apiConfig.howToKnow}/${franchiseId}`;
                const leadSources: LeadSourceArray = await cachedAPIWrapper(dynamic_url);
                const othersLeadSource: LeadSource | undefined = leadSources.find(
                    (source: LeadSource) => source?.leadSourceName.toLocaleLowerCase() === "others"
                );

                if (othersLeadSource?.referralTypeId) {
                    requestBody.referralTypeId = othersLeadSource.referralTypeId;
                }
                if (othersLeadSource?.leadSourceName) {
                    requestBody.referralType = othersLeadSource.leadSourceName;
                }

            }
        } catch (error) {
            console.error('An error occurred in generic-lead-sources API in ResidentialForm.ts file:', error);
        }

        if(formFields.isResidential){
            if(requestBody.note){
                requestBody.note+=" , ";
            }
            requestBody.note += formFields.isResidential;
        }

        const out = await handleMissingData(requestBody.city, requestBody.state, requestBody.zipCode);
        requestBody.city = out?.city || requestBody.city;
        requestBody.state = out?.state || requestBody.state;
        const tabBodyDiv = this.form?.closest('.tab-body');

        try {
            let isShowModal = modalVisibilityCheck(requestBody?.zipCode?.trim());
            const domain = DomainIdentifier();
      
            const localisation = LocalizationIdentifier();
            // Default value to pass if checkbox is not found
            let checkboxId = '';
            const countryZip = !REGEX.sendCaPostalCode.test(requestBody.zipCode?.trim() || '') ? 'us' : 'ca';
            if ((((domain === "us" && !localisation) || (domain === "us" && localisation=="us")) && countryZip === 'us') || isShowModal) {
                checkboxId = 'short-form-service-reminder-us';
            } else {
                checkboxId = 'short-form-service-reminder-ca';
            }

            if (this.isCAReminderModal) {
                isShowModal = false;
            }
        
            this.noteWithRequestBody = disclaimerHandleCheck(isShowModal, tabBodyDiv, requestBody, requestBody.zipCode, checkboxId);
            const serviceReminderModal = document.querySelector('.service-reminder-ca-modal') as HTMLElement;

            if (isShowModal && !this.isCAReminderModal && serviceReminderModal && countryZip=='ca' && localisation !== 'ca') {
                stopLoader();
                this.isCAReminderModal = true;
                document.getElementById("service-reminder-modal")?.querySelector(".primary-btn")?.addEventListener("click", () => {
                    startLoader();
                    const checkbox = tabBodyDiv.querySelector(`#${checkboxId}`);
                    if (checkbox) {
                        checkbox.checked = true;
                    }
                    //  prevent recursive reopen on fake submit
                    if (requestBody.firstName?.toLowerCase() !== "isfakesubmit" || requestBody.lastName?.toLowerCase() !== "isfakesubmit") {
                        this.handleSubmit(event, data, zipcodeInput);
                        (document.querySelector('.service-reminder-ca-modal') as HTMLAnchorElement)?.click();
                    } else {
                        this.handleSubmit(event, data, zipcodeInput);
                        stopLoader();
                        (document.querySelector('.service-reminder-ca-modal') as HTMLAnchorElement)?.click();
                    }
                });
                document.getElementById("service-reminder-modal")?.querySelectorAll(".primary-outline-btn,#close-reminder-local-modal")?.forEach(element => {
                    element.addEventListener("click", () => {
                    startLoader();
                        // prevent recursive reopen on fake submit
                        if (requestBody.firstName?.toLowerCase() !== "isfakesubmit" || requestBody.lastName?.toLowerCase() !== "isfakesubmit") {
                            this.handleSubmit(event, data, zipcodeInput);
                        } else {

                            this.handleSubmit(event, data, zipcodeInput);
                            stopLoader();
                        }
                    });
                });
                const modalDiv = document.querySelector("#service-reminder-modal") as HTMLDivElement;
                const modal = new Modal(modalDiv);
                const self = this;
                if(modalDiv){
                    modalDiv.onclick = function(event) {
                        startLoader();
                        if (event.target === modalDiv) {
                            modal?.hide();
                        }
                        // prevent recursive reopen on fake submit
                        if (requestBody.firstName?.toLowerCase() !== "isfakesubmit" || requestBody.lastName?.toLowerCase() !== "isfakesubmit") {
                            (document.querySelector('.service-reminder-ca-modal') as HTMLAnchorElement)?.click();
                            self.handleSubmit(event, data, zipcodeInput);
                        }
                        else {
                            stopLoader(); // stop loader only
                        }
                    }
                  };
                return false;
            } else {

                if (this.noteWithRequestBody?.note) {
                    requestBody.note = this.noteWithRequestBody.note;
                }
                if (this.noteWithRequestBody?.comments) {
                    requestBody.comments = this.noteWithRequestBody.comments;
                }
               
                requestBody.optIn = this.noteWithRequestBody.optIn;
                requestBody.emailOptOut = this.noteWithRequestBody.emailOptOut;
                
                this.isCAReminderModal = false;
            }

        } catch (error) {
            console.error('An error occurred in disclaimerHandleCheck in ResidentialForm.ts file:', error);
        }

            let formDiv = tabBodyDiv?.querySelector('.residential-form-container') as HTMLFormElement;
            let formDivHeader = tabBodyDiv?.querySelector('.form-heading-container') as HTMLFormElement;
            let thankYouHeader = tabBodyDiv?.querySelector('#thank-you-header') as HTMLFormElement;
            let thankYouDesc = tabBodyDiv?.querySelector('#thank-you-description') as HTMLFormElement;
            let errorMsg = tabBodyDiv?.querySelector('#error--header') as HTMLFormElement;
            let eroorDesc = tabBodyDiv?.querySelector('#error-description') as HTMLFormElement;

            if (isShortForm) {
                const currentSectionDom = this.form?.closest('.short-form-component')
                formDiv = currentSectionDom.querySelector('.residential-form-container') as HTMLFormElement;
                formDivHeader = currentSectionDom.querySelector('.form-heading-container') as HTMLFormElement;
                thankYouHeader = currentSectionDom.querySelector('#shortform-thank-you-header') as HTMLFormElement;
                thankYouDesc = currentSectionDom.querySelector('#shortform-thank-you-description') as HTMLFormElement;
                errorMsg = currentSectionDom.querySelector('#shortform-error--header') as HTMLFormElement;
                eroorDesc = currentSectionDom.querySelector('#shortform-error-description') as HTMLFormElement;
            }

            if(formFields?.serviceText){
                requestBody.serviceText = formFields?.serviceText;
            }

            const shouldRedirectToLeadFlow = this.getShouldRedirectToLeadFlow();
            if(shouldRedirectToLeadFlow) {
                const type = requestBody.customerType;
                if(type){
                    requestBody.customerType = type.toLowerCase();
                }
                else{
                    requestBody.customerType = defaultCustomerType?.toLowerCase() || 'residential';
                }                
                const formdata = JSON.stringify(requestBody);
                sessionStorage.setItem('formValues', formdata);
                sessionStorage.setItem('shouldRedirectToLeadFlow', 'true');

                const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
                const brandData = await getBrandDetailsFromBrandJson(conceptCode);

                if(!brandData?.request_button_link_type) return;

                globalThis.location.href = `${globalThis.location.origin}${brandData?.request_button_link_type}`;
                
                stopLoader();
                return;
            } else {
                sessionStorage.removeItem('shouldRedirectToLeadFlow');
            }
            await bookingUsPostCallWrapper(apiConfig.BOOKING_API_URL, requestBody, true).then((response: any) => {
                    localStorage.setItem('weblocationId',requestBody.webLocationId.toString());
                    stopLoader();
                    const submitObj = {
                        event: 'opus_form_submit_ev',
                        status: 'success'
                    }
                    gtmCustomEventLeadFlow(submitObj);
                    storeBookingApiPayload(requestBody, response);
                    formDiv.remove();
                    formDivHeader?.remove();
                    thankYouHeader?.classList.remove("hidden");
                    thankYouDesc?.classList.remove("hidden");
                    this.scrollToThankYouSection(tabBodyDiv);
                    const closeModal = document.getElementById('close-local-modal');
                    if (closeModal) {
                        closeModal.click();
                    }
                    insertAfterUrl();
                    this.createHiddenLocalWeblocalIdInput(id);
                })
                .catch((err) => {
                    stopLoader();
                    const submitObj = {
                        event: 'opus_form_submit_ev',
                        status: 'failure'
                    }
                    gtmCustomEventLeadFlow(submitObj);
                    this.handleCloseNearByLocationsModal();
                    errorMsg?.classList.remove("hidden");
                    eroorDesc?.classList.remove("hidden");
                    formDiv?.remove();
                    formDivHeader?.remove();
                });

    }

    private setAutoSuggested = async (e: any) => {
        this.form = (e.target as HTMLElement).closest('form');
        window.isShortForm = this.form;

        e.preventDefault()
        if (this.validateInputs()) {
            const formFields = this.getFormFields();
            const addressId = formFields?.addressInput?.id;
            const zipcodeElem = this.form.querySelector(`#${addressId}`)
            if(!zipcodeElem) return;
            const zipcode = (zipcodeElem as HTMLInputElement).value;
            if(!zipcode) return;
            const formattedZipCode = this.formatZipCode(zipcode);
            try{
                const conceptCode = (document.getElementById('conceptCode') as HTMLInputElement)?.value;
                const brandData = await getBrandDetailsFromBrandJson(conceptCode);
                if(brandData.send_nonagnostic_to_contact_endpoint){
                    console.log("Skipping booking call due to brand config 'send_nonagnostic_to_contact_endpoint'")
                    await this.contactUsApiCall(formattedZipCode)
                    return;
                }
            }
            catch(error){
                console.error('Error in fetching getBrandDetailsFromBrandJson API data:', error);
            }
            
            const request = {
                method: 'GET',
                url: `${apiConfig.DISCOVER_API}?q=${formattedZipCode}&in=countryCode%3AUSA%2CCAN%2CPRI&at=0,0&apiKey=${process.env.JS_Heremap_API_KEY}`
            }
            apiRequest(request)
                .then((result: any) => {
                    if (result?.items.length > 0) {
                        this.privateSuggestedArray = result?.items
                        const zipcodeData = result?.items[0];
                        const usZipCode = !REGEX.sendCaPostalCode.test(zipcode?.trim());
                        const hasHyphenInZipCode = zipcodeData?.address?.postalCode?.includes('-') && usZipCode;
                        if (hasHyphenInZipCode) {
                        const baseZipCode = zipcodeData.address.postalCode.split('-')[0];
                        zipcodeData.address.postalCode = baseZipCode?.trim();
                        }
                        const updatedData = this.getAddress(zipcodeData);
                        let selectedRadio = formFields.leadServiceId;

    
                        if (selectedRadio) {
                            //pass the selectedRadio
                            this.getFranchiseWebLocationId(e, updatedData, selectedRadio);
                        }
                        else {
                            this.getFranchiseWebLocationId(e, updatedData);
                        }
                        
                    } else {
                        this.handleErrorcase(1);
                    }
                })
                .catch((err) => {
                    this.handleErrorcase(1);
                });
        }
    }

    private getAddress(data: any) {
        let newData = data;
        newData.title = "No address collected";
        return newData;
    }

    private handleErrorcase(inputArg = 0) {
        let isShortForm = this.form?.closest('.short-form-component') || (globalThis as any)?.isShortForm?.closest('.short-form-component');
        let errorMsg: any, eroorDesc: any, noService: any, currentElement: any, noServiceDescriptn: any;
        const parentContainer = this.form?.closest('.residential-form-container') || (globalThis as any)?.isShortForm?.closest('.residential-form-container');
        if (parentContainer) {
            currentElement = parentContainer.parentElement;
            if (currentElement) {
                errorMsg = currentElement.querySelector('#error--header');
                eroorDesc = currentElement.querySelector('#error-description');
                noService = currentElement.querySelector('#no-service-header');
                noServiceDescriptn = currentElement.querySelector('#no-service-description');
            }
        }

        if (isShortForm) {
            const formHeading = isShortForm.querySelector(".form-heading-container") as HTMLFormElement;
            const formContainer = isShortForm.querySelector('div[class*="form-container"]') as HTMLFormElement;
            errorMsg = isShortForm.querySelector('#shortform-error--header') as HTMLFormElement;
            eroorDesc = isShortForm.querySelector('#shortform-error-description') as HTMLFormElement;
            noService = isShortForm.querySelector('#shortform-no-service-header') as HTMLFormElement;
            const noServiceDesc = isShortForm.querySelector('#shortform-no-service-description') as HTMLFormElement;
            formHeading.classList.add("hidden");
            formContainer.classList.add("hidden");
            if (inputArg === 1) {
                errorMsg.classList.remove("hidden");
                eroorDesc.classList.remove("hidden");
                noService.classList.add("hidden");
                noServiceDesc.classList.add("hidden");
            }
            else {
                errorMsg.classList.add("hidden");
                eroorDesc.classList.add("hidden");
                noService.classList.remove("hidden");
                noServiceDesc.classList.remove("hidden");
            }
            this.scrollToThankYouSection();
        }
        else {
            if(inputArg === 1) {
                errorMsg?.classList.remove("hidden");
                eroorDesc?.classList.remove("hidden");
                noService?.classList.add("hidden");
                noServiceDescriptn?.classList.add("hidden");
            } else {
                errorMsg?.classList.add("hidden");
                eroorDesc?.classList.add("hidden");
                noService?.classList?.remove("hidden");
                noServiceDescriptn?.classList.remove("hidden");
            } 
            const formHeading = currentElement?.querySelector(".form-heading-container") as HTMLFormElement;
            const formContainer = currentElement?.querySelector('div[class*="form-container"]') as HTMLFormElement;
            formHeading?.classList.add("hidden");
            formContainer?.classList.add("hidden");
            this.scrollToThankYouSection();
        }
        stopLoader();
    }

    private asideCardToMobile() {
        const asideCard = document.querySelector('.aside-card.tabs') as HTMLElement;
        const asideCardMobile = document.querySelector('.aside-card.tabs-mobile') as HTMLElement;

        try {

            if (asideCard && asideCardMobile) {
                if (window.innerWidth <= 768) {
                    while (asideCard.firstChild) {
                        asideCardMobile.appendChild(asideCard.firstChild);
                    }
                } else {
                    while (asideCardMobile.firstChild) {
                        asideCard.appendChild(asideCardMobile.firstChild);
                    }
                }
            }

        } catch (error) {
            console.log("Error in Residential form: ", error);
        }

    }

    handleCloseNearByLocationsModal() {
        const closeModalButton = document.querySelector("#findnearby-user-zip-code .close-modal-btn") as HTMLButtonElement;
        if (closeModalButton) {
            closeModalButton.click();
        }
    }

    async checkToShowCARemainderModal(
        requestBody: any, 
        zipcodeInput: any, 
        event: any,
        serviceId: string
    ): Promise<boolean> {
        try {
            let isShowModal = modalVisibilityCheck(requestBody?.zipCode?.trim());
            const domain = DomainIdentifier();
      
            const localisation = LocalizationIdentifier();
            // Default value to pass if checkbox is not found
            let checkboxId = '';
            const countryZip = REGEX.sendCaPostalCode.test(requestBody.zipCode?.trim() || '') ? 'ca' : 'us';
            if (((domain === "us" && !localisation) || (domain === "us" && localisation=="us")) && countryZip === 'us') {
                checkboxId = 'short-form-service-reminder-us';
            } else {
                checkboxId = 'short-form-service-reminder-ca';
            }
        
            const tabBodyDiv = this.form?.closest('.tab-body');
            const serviceReminderModal = document.querySelector('.service-reminder-ca-modal') as HTMLElement;

            if (isShowModal && serviceReminderModal && countryZip=='ca' && localisation !== 'ca') {
                serviceReminderModal.click();
                stopLoader();
                this.isCAReminderModal = true;
                document.getElementById("service-reminder-modal")?.querySelector(".primary-btn")?.addEventListener("click", () => {
                    startLoader();
                    const checkbox = tabBodyDiv.querySelector(`#${checkboxId}`);
                    if (checkbox) {
                        checkbox.checked = true;
                    }
                    this.fetchNearByLocations(event, zipcodeInput, serviceId);
                    if (requestBody.firstName?.toLowerCase().includes("isfakesubmit") || requestBody.lastName?.toLowerCase().includes("isfakesubmit")) {
                        stopLoader();
                    }
                    (document.querySelector('.service-reminder-ca-modal') as HTMLAnchorElement)?.click();
                });
                const elements = document.getElementById("service-reminder-modal")?.querySelectorAll(".primary-outline-btn,#close-reminder-local-modal") ?? [];
                for (const element of elements) {
                    element.addEventListener("click", () => {
                        startLoader();
                        this.fetchNearByLocations(event, zipcodeInput, serviceId);
                        if (requestBody.firstName?.toLowerCase().includes("isfakesubmit") || requestBody.lastName?.toLowerCase().includes("isfakesubmit")) {
                            stopLoader();
                        }
                    });
                }
                const modalDiv = document.querySelector("#service-reminder-modal") as HTMLDivElement;
                const modal = new Modal(modalDiv);
                if(modalDiv){
                    modalDiv.onclick = (event) => {
                        startLoader();
                        if (event.target !== modalDiv) {
                            modal?.hide();
                            return;
                        }
                        if (requestBody.firstName?.toLowerCase().includes("isfakesubmit") || requestBody.lastName?.toLowerCase().includes("isfakesubmit")) {
                            stopLoader();
                        } else {
                            (document.querySelector('.service-reminder-ca-modal') as HTMLAnchorElement)?.click();
                            this.fetchNearByLocations(event, zipcodeInput, serviceId);
                        }
                    }
                };
                return true;
            } else {
                this.isCAReminderModal = false;
                return false;
            }
        } catch (error) {
            console.error('An error occurred in handleCAReminderModal in ResidentialForm.ts file:', error);
            return false;
        }
    }

    constructNearbyLocationsModal(sortedResultData: any, unit = "miles") {
        const ul = document.querySelector('.user-zip-result-list') as HTMLElement;
        ul.innerHTML = '';
        if (sortedResultData) {
            for (const item of sortedResultData) {
                const liElement = document.createElement('li');
                liElement.className = 'user-zip-result-item';
                if(unit.includes('mi')) {
                    unit = 'mi.';
                    item.distance = item.distance * 0.621371;
                }
                const distanceRounded = Math.round(item.distance) + ' ' + unit;
                const pNum = item?.websiteTrackingPhone?.length > 0 ? item.websiteTrackingPhone[0] : item.phoneNumber;
                
                const locationButton = item?.websiteUrl ? 
                    '<div class="locaion-btn"><button class="btn primary-btn">Select Location</button></div>' : 
                    '';
                
                liElement.innerHTML = `
                    <div class="locaion-info">
                        <div class="locaion-time">
                        <svg aria-hidden="true" class="icon">
                            <use xlink:href="/brand/_assets/images/icons/hero-icon-sprite.svg#map-pin-primary"></use>
                        </svg>
                        <span class="location-text">${distanceRounded}</span>
                        </div>
                        <div class="locaion-name">
                        <p class="location-main">${item?.doingBusinessAs}</p>
                        <a class="location-call" href="tel:${pNum}">(${pNum?.slice(0, 3)}) ${pNum?.slice(3, 6)}-${pNum?.slice(6)}</a>
                        <p class="location-zip-code hidden">${item?.zipCode}</p>
                        </div>
                    </div>
                ${locationButton}`;
                ul?.appendChild(liElement);
            }
        }
    }
    
    displayNearByLocations(resultData: any, zipcodeInput: any, unit = "miles") {
        stopLoader();
        const modal = document.getElementById("findnearby-user-zip-code");
        if(!modal) return;
        
        const zipcode = zipcodeInput?.address?.postalCode.trim();
        const totalResults = resultData?.length;
        const resultsTextElement = document.querySelector('.results-text');
        if (resultsTextElement && zipcode) {
            resultsTextElement.textContent = ` ${totalResults} Results for ${zipcode}`;
        }
        
        const sortedResultData = resultData?.slice()?.sort((a: any, b: any) => a.distance - b.distance);
        this.constructNearbyLocationsModal(sortedResultData, unit);
        const closeModalButton = document.querySelector("#findnearby-user-zip-code .close-modal-btn") as HTMLButtonElement;
        if (closeModalButton) {
            closeModalButton.addEventListener('click', () => {
                modal?.classList.add("hidden");
            });
        }
        (document.querySelector('.findnearby-modal') as HTMLElement)?.click();

        const primaryButtons = document.querySelectorAll<HTMLAnchorElement>('.locaion-btn .btn.primary-btn');
        for (const button of primaryButtons) {
            button.addEventListener('click', async (event: MouseEvent) => {
                event.preventDefault();
                const anchor = event.currentTarget as HTMLAnchorElement;
                const listItem = anchor.closest('li.user-zip-result-item');
                if (listItem) {
                    const locationMain = listItem.querySelector<HTMLParagraphElement>('.location-main')?.textContent;
                    let matchingData = resultData.find((data: any) => data.doingBusinessAs === locationMain);
                    if (matchingData) {
                        await localizationHelper([matchingData], true, false);
                        // Set session storage flag to indicate this comes from nearby locations
                        sessionStorage.setItem('isNearbyRedirect', 'true');
                        
                        let data = {
                            city: matchingData?.city,
                            state: matchingData?.state,
                            franchiseWebLocationId: Number(matchingData?.franchiseWebLocationId),
                            franchiseId: matchingData?.franchiseId,
                            licenseNumber: matchingData?.licenseNumber ?? ''
                        }
                        this.handleCloseNearByLocationsModal();
                        this.handleSubmit(event, data, zipcodeInput);
                    }
                }
            });
        }
    }


    handleLocationResults(event: any, result: any, zipcodeInput: string) {
        const obj = {
            'franchiseId': result[0].franchiseId,
            'franchiseWebLocationId': result[0].franchiseWebLocationId
        }
        const doingBusinessAs = result[0].doingBusinessAs;
        const locationUrl =  result[0].locationWebsiteUrl?.replace(/\/$/, '') ?? '';
        const splitUrlArr = locationUrl.toLowerCase().split("/");
        const pathname = splitUrlArr[splitUrlArr.length - 1];
        if(pathname){
            localStorage.setItem('dbaName', pathname);
            localizationTagUpadation();
        }
        localStorage.setItem("franchiseWebLocationId", result[0]?.franchiseWebLocationId);
        localStorage.setItem('doingBusinessAs', doingBusinessAs);
        this.handleSubmit(event, obj, zipcodeInput);
    }

    private handleNearbyLocationsResponse(data: any, event: any, zipcodeInput: any, unit: string, brandData: any) {
        if (data?.length > 1) {
            this.displayNearByLocations(data, zipcodeInput, unit);
        } else if (data?.length === 1) {
            sessionStorage.setItem('isNearbyRedirect', 'true');
            this.handleLocationResults(event, data, zipcodeInput);
        } else if (brandData?.lead_contactapi) {
            this.contactUsApiCall(zipcodeInput);
        } else {
            this.handleErrorcase(data === null ? 1 : 0);
        }
    }

    async fetchNearByLocations(event: any, zipcodeInput: any, serviceId: string) {
        const conceptCode = document.getElementById('conceptCode') as HTMLInputElement;
        const brandData = await getBrandDetailsFromBrandJson(conceptCode?.value);
        const zipcode = zipcodeInput?.address?.postalCode.trim();

        sessionStorage.setItem('serviceIdValue', serviceId);

        try {
            const limit = Number(brandData?.nearest_franchiselimit_shortform) || 50;
            const unit = brandData?.area_measure_values_shortform?.includes('miles') ?? false ? 'miles' : 'km';
            let data;
            
            if (brandData?.use_miles_endPoint) {
                const nearbyLocationsMiles = new NearbyLocationsMiles(zipcode, conceptCode?.value, ComponentType.SHORT_FORM, serviceId);
                data = await nearbyLocationsMiles.searchNearbyLocations();
            } else {
                let nearbyLocations = new NearbyLocations(unit, limit);
                data = await nearbyLocations.searchNearbyLocations(zipcode);
            }

            this.handleNearbyLocationsResponse(data, event, zipcodeInput, unit, brandData);
        } catch (error: any) {
            this.handleErrorcase(1);
            console.error('Error searching nearby locations:', error);
        }
    }

    async handleNearByLocations(event: any, zipcodeInput: any, serviceId: string) {
        
        try {
            const requestBody = this.getFormFields();
            const modalShown = await this.checkToShowCARemainderModal(
                requestBody, 
                zipcodeInput, 
                event,
                serviceId
            );
            
            if (!modalShown) {
                this.fetchNearByLocations(event, zipcodeInput, serviceId);
            }
        } catch (error) {
            console.error('An error occurred while showing CA Remainder modal:', error);
            this.fetchNearByLocations(event, zipcodeInput, serviceId);
        }
    }

    private async getFranchiseWebLocationId(event: Event, zipcodeInput: any, selectedRadio?: any) {
        event.preventDefault();
        const formFields = this.getFormFields();
        const zipCode: any = zipcodeInput;
        const tabBodyDiv = this.form?.closest('.tab-body')
        let errorMsg = tabBodyDiv?.querySelector('#error--header') as HTMLFormElement;
        let eroorDesc = tabBodyDiv?.querySelector('#error-description') as HTMLFormElement;
        let isShortForm = this.form?.closest('.short-form-component');

        if (isShortForm) {
            const currentSectionDom = this.form?.closest('.short-form-component')
            errorMsg = currentSectionDom.querySelector('#shortform-error--header') as HTMLFormElement;
            eroorDesc = currentSectionDom.querySelector('#shortform-error-description') as HTMLFormElement;
        }

        if (this.validateInputs()) {
            startLoader();

            const conceptCode = document.getElementById('conceptCode') as HTMLInputElement;
            const brandData = await getBrandDetailsFromBrandJson(conceptCode?.value);
            if(brandData?.send_leadform_contactus_api && !isShortForm) { // This is applicable for lead form only
                this.contactUsApiCall(zipcodeInput);
                return;
            }

            if(brandData?.send_shortleadform_contactus_api && isShortForm) { // This is applicable for short lead body component form only
                this.contactUsApiCall(zipcodeInput);
                return;
            }
            const serviceId = selectedRadio;
            getFranchiseDetails(zipCode?.address?.postalCode.trim(),false,serviceId) // IsRobinRound is false
            .then(async (response: any) => {
                const result = response;
                if (result.length > 0) {
                    this.handleLocationResults(event, result, zipcodeInput);
                } else if(result.length === 0 && brandData?.enable_50mile_areameasure_shortform && !brandData?.send_shortform_lead_bookingapi) {
                    this.handleNearByLocations(event, zipcodeInput, serviceId);
                } else {
                    const dbaName = (document.getElementById('dbaName') as HTMLInputElement)?.value ?? localStorage.getItem('dbaName');
                    if (!brandData?.send_shortform_lead_bookingapi || !dbaName) {

                        if (!brandData?.lead_contactapi) {
                            this.handleErrorcase();
                        } else {
                            this.contactUsApiCall(zipcodeInput);
                        }
                    } else {
                        const obj = {
                            'franchiseId': null,
                            'franchiseWebLocationId': localStorage.getItem('weblocationId')
                        }
                        this.handleSubmit(event, obj, zipcodeInput);
                    }
                    stopLoader()
                }
            })
                .catch(async (error) => {
                    stopLoader();
                    const conceptCode = document.getElementById('conceptCode') as HTMLInputElement;
                    const brandData = await getBrandDetailsFromBrandJson(conceptCode?.value);

                    const step1 = document.querySelector('.step-1') as HTMLElement;
                    if (step1) {
                        step1.classList.add('hidden');
                    }
                    if (typeof error?.then === 'function') {
                        error = await error;
                    }
                        
                    let message = error?.response?.data?.message;
                    if(!message){
                        message = error?.message;
                    } 
                    if(!message){
                        message = '';
                    }
                    
                    if (message.toLowerCase() === "full address is needed to narrow down results") {
                        const stateHandler = new StateHandler();
                        stateHandler.getStateFun();
                        const findLocalBtn = document.querySelector(".find-local") as HTMLElement;
                        findLocalBtn?.click();
                        const step2 = document.querySelector('.step-2') as HTMLElement;
                        if (step2) {
                            step2.classList.remove('hidden');
                            step2.classList.add('block');

                            const closeLocalModal = document.querySelector('.close-modal-btn');
                            closeLocalModal?.addEventListener('click', function handleClick(event) {
                                step2.classList.add("hidden");
                                step1.classList.remove("hidden");
                            });
                        }
                        const modalZipCode = document.querySelector('.step-2 #modal-zipcode') as HTMLInputElement;

                        modalZipCode.value = formFields.addressInput?.value;
                        sessionStorage.setItem('shortFormAddressBumper', 'true');

                        const locateAddressBumper = new LocateAddressBumper();
                    } else {
                        if (!brandData?.lead_contactapi) {
                     
                            let formDiv = tabBodyDiv?.querySelector('.residential-form-container') as HTMLFormElement;
                            let formDivHeader = tabBodyDiv?.querySelector('.form-heading-container') as HTMLFormElement;
                            formDiv?.remove();
                            formDivHeader?.remove();
                            errorMsg?.classList.remove("hidden");
                            eroorDesc?.classList.remove("hidden");

                        } else {
                            this.contactUsApiCall(zipcodeInput);
                        }
                    }

                });
        }
    }

    async contactUsApiCall(zipcodeInput: any) {

        const formFields = (globalThis as any).getFormFields ?? this.getFormFields();
        this.form = (globalThis as any).isShortForm ?? this.form;
        const conceptCode = document.getElementById('conceptCode') as HTMLInputElement;
        const conceptId = document.getElementById('conceptId') as HTMLInputElement;
        const lastName = formFields.lastNameInput?.value ?? '';
        const addressZip: any = zipcodeInput;

        const tabBodyDiv = this.form?.closest('.tab-body')
        let formDiv = tabBodyDiv?.querySelector('.residential-form-container') as HTMLFormElement;
        let formDivHeader = tabBodyDiv?.querySelector('.form-heading-container') as HTMLFormElement;
        let thankYouHeader = tabBodyDiv?.querySelector('#thank-you-header') as HTMLFormElement;
        let thankYouDesc = tabBodyDiv?.querySelector('#thank-you-description') as HTMLFormElement;
        let errorMsg = tabBodyDiv?.querySelector('#error--header') as HTMLFormElement;
        let eroorDesc = tabBodyDiv?.querySelector('#error-description') as HTMLFormElement;
        const isShortForm = this.form?.closest('.short-form-component');
        let shortFormComment = '';
        if (isShortForm) {
            const currentSectionDom = this.form?.closest('.short-form-component')
            formDiv = currentSectionDom.querySelector('.residential-form-container') as HTMLFormElement;
            formDivHeader = currentSectionDom.querySelector('.form-heading-container') as HTMLFormElement;
            thankYouHeader = currentSectionDom.querySelector('#shortform-thank-you-header') as HTMLFormElement;
            thankYouDesc = currentSectionDom.querySelector('#shortform-thank-you-description') as HTMLFormElement;
            errorMsg = currentSectionDom.querySelector('#shortform-error--header') as HTMLFormElement;
            eroorDesc = currentSectionDom.querySelector('#shortform-error-description') as HTMLFormElement;
            shortFormComment  = currentSectionDom.querySelector('#short-form-req-comment')?.value; 
        }

        let vendorId;

        try {

            const brandData = await getBrandDetailsFromBrandJson(conceptCode?.value);
            if (brandData.lead_contactapi || brandData?.send_leadform_contactus_api || brandData?.send_shortleadform_contactus_api || brandData?.send_nonagnostic_to_contact_endpoint) {
                if (brandData) {
                    vendorId = brandData.vendorId;
                }
                let comments: string = '';
                if (brandData.osflow_contactUs_comments?.length > 0) {
                    comments = brandData.osflow_contactUs_comments;
                }
                if(brandData?.send_leadform_comments && !isShortForm) {
                    // If the brandData has send_leadform_comments, append it to the comments & comma as well
                    if(comments){
                        comments += " , ";
                    }
                    comments +=  brandData?.send_leadform_comments;
                }

                // Short lead body component form 
                if(brandData?.send_shortleadform_comments && isShortForm) {
                    if(comments){
                        comments += " , ";
                    }
                    comments +=  brandData?.send_shortleadform_comments;
                }
                const requestBody: ContactUsPayloadModel = {
                    "firstName": formFields.nameInput?.value.split(' ')[0] ? formFields.nameInput?.value.split(' ')[0] : '',
                    "lastName": formFields.nameInput?.value.split(' ')[1] ? formFields.nameInput?.value.split(' ')[1] : ' ',
                    "zipCode": brandData?.send_nonagnostic_to_contact_endpoint ? zipcodeInput : addressZip?.address?.postalCode.trim(),
                    "email": formFields.emailInput?.value,
                    "state": addressZip?.address?.state,
                    "city": addressZip?.address?.city,
                    "phone": formFields.phoneInput?.value,
                    "address": addressZip?.title ? addressZip?.title : this.getAddressValue(formFields, addressZip?.address?.label),
                    "address2": '',
                    "country": addressZip?.address?.country ?? '',
                    "comments": comments,
                    "signUpForUpdates": false,
                    "isLocalized": conceptId?.value ==="25",
                    "isNewCustomer": "",
                    "isTest": true,
                    "conceptId": Number(conceptId?.value),
                    "vendorId": Number(vendorId),
                    "companyName": formFields.businessNameInput?.value || ''
                };
                // Make isLocalized to true for brands other than HMS based on the 'send_leadform_contactus_api' flag
                if((brandData?.send_leadform_contactus_api && !brandData?.send_leadform_value && !isShortForm) || (brandData?.send_shortleadform_contactus_api && isShortForm && !brandData?.send_shortleadform_value)) {
                    const franchiseId = await getFranchiseWebLocationIdDetails(addressZip?.address?.postalCode.trim());
                    if (conceptId?.value !== "25" && franchiseId) {
                        requestBody.franchiseWebLocationId = Number(franchiseId);
                        requestBody.isLocalized = true;
                    }
                }
                if(shortFormComment){
                    if(requestBody.comments){
                        requestBody.comments += " , ";
                    }
                    requestBody.comments += shortFormComment;
                }
                const host = window.location.hostname.toLowerCase();
                if (host.includes('nblysbx') || host.includes('nblydev') || host.includes('nblytest') || host.includes('localhost')) {
                    requestBody.isTest = true;
                } else {
                    requestBody.isTest = false;
                }
                if (lastName) {
                    requestBody.lastName = lastName;
                    requestBody.firstName = formFields.nameInput?.value ?? '';
                }
                
                try {
                    let isShowModal = modalVisibilityCheck(requestBody?.zipCode?.trim());
                    
                    const domain = DomainIdentifier();
                    const localisation = LocalizationIdentifier();
                    // Default value to pass if checkbox is not found
                    let checkboxId = '';
                    
                    const countryZip = !REGEX.sendCaPostalCode.test(requestBody.zipCode?.trim()) ? 'us' : 'ca';
                    if ((((domain === "us" && !localisation) || (domain === "us" && localisation=="us")) && countryZip === 'us') || isShowModal) {
                        checkboxId = 'short-form-service-reminder-us';
                    } else {
                        checkboxId = 'short-form-service-reminder-ca';
                    }

                    if (this.isCAReminderModal) {
                        isShowModal = false;
                    }

                    this.noteWithRequestBody = disclaimerHandleCheck(isShowModal, tabBodyDiv, requestBody, requestBody.zipCode,checkboxId);
                    const serviceReminderModal = document.querySelector('.service-reminder-ca-modal') as HTMLElement;

                    if (isShowModal && !this.isCAReminderModal && serviceReminderModal && countryZip=='ca'  && localisation !== 'ca') {
                        stopLoader();
                        this.isCAReminderModal = true;
                        document.getElementById("service-reminder-modal")?.querySelector(".primary-btn")?.addEventListener("click", () => {
                            startLoader();
                            this.contactUsApiCall(zipcodeInput);
                            const checkbox = tabBodyDiv.querySelector(`#${checkboxId}`);
                            if (checkbox) {
                                checkbox.checked = true;
                            }
                            (document.querySelector('.service-reminder-ca-modal') as HTMLAnchorElement)?.click();
                        });

                        document.getElementById("service-reminder-modal")?.querySelectorAll(".primary-outline-btn,#close-reminder-local-modal")?.forEach(element => {
                            element.addEventListener("click", () => {
                            startLoader();
                            this.contactUsApiCall(zipcodeInput);
                            });
                        });

                        const modalDiv = document.querySelector("#service-reminder-modal") as HTMLDivElement;
                        const modal = new Modal(modalDiv);
                        const self = this;
                        if(modalDiv){
                            modalDiv.onclick = function(event) {
                                startLoader();
                                if (event.target === modalDiv) {
                                    modal?.hide();
                                }
                                (document.querySelector('.service-reminder-ca-modal') as HTMLAnchorElement)?.click();
                                self.contactUsApiCall(zipcodeInput);
                            }
                        };

                        return false;
                    } else {

                        if (this.noteWithRequestBody?.comments) {
                            requestBody.comments = this.noteWithRequestBody.comments;
                        }
                        requestBody.optIn = this.noteWithRequestBody.optIn;
                        requestBody.emailOptOut = this.noteWithRequestBody.emailOptOut;
                        this.isCAReminderModal = false;
                     
                    }
                    const shortLeadBodyForm = (isShortForm && brandData?.send_shortleadform_value);
                    const shortLeadForm = (!isShortForm && brandData?.send_leadform_value);

                    if (shortLeadForm || shortLeadBodyForm) {
                        if(shortLeadBodyForm){
                            requestBody.formType = brandData?.send_shortleadform_value ?? '';
                        }
                        if(shortLeadForm){
                            requestBody.formType = brandData?.send_leadform_value ?? '';
                        }
                        delete requestBody.franchiseWebLocationId;
                        requestBody.isLocalized = false;
                    }
        
                } catch (error) {
                    console.error('An error occurred in disclaimerHandleCheck in ResidentialForm.ts file:', error);
                }
                const el = document.getElementById('conceptId') as HTMLInputElement | null;
                const value = el?.value ? el.value.trim().toLowerCase() : '';
                if(value === process.env.CONCEPT_CORP) {
                    try {
                        await NblyBrandContactUs.getInstance().callParallelEmails(requestBody);
                    } catch (err) {
                        console.error('Error sending Nbly brand contact emails:', err);
                        throw err;
                    }
                }
                else{
                    await contactUsPostCallWrapper(apiConfig.CONTACT_US_SEND, requestBody);
                }
                formDiv?.remove();
                formDivHeader?.remove();
                if (thankYouHeader) {
                    thankYouHeader.classList.remove("hidden");
                    thankYouDesc.classList.remove("hidden");
                }
                this.scrollToThankYouSection(tabBodyDiv);
                stopLoader();
            }
        }
        catch (error) {
            console.error(`Error in Residential.ts file in the contactUsApiCall function. Error message: ${error}`);
            errorMsg?.classList.remove("hidden");
            eroorDesc?.classList.remove("hidden");
            formDiv?.remove();
            formDivHeader?.remove();
            stopLoader();
        }
    }

    public createHiddenLocalWeblocalIdInput(id: any): void {
        const localWebLocationIdInput: HTMLInputElement = document.createElement('input');
        localWebLocationIdInput.type = 'hidden';
        localWebLocationIdInput.value = id;
        localWebLocationIdInput.id = 'local_weblocationId';
        document.body.appendChild(localWebLocationIdInput);
    }

    formatZipCode(input: string): string {
        if(!input) return '';
        
        try {
            // Remove all non-alphanumeric characters from the input
            const cleanedInput = input.replace(/[^A-Z0-9]/gi, '').toUpperCase();
            
            // Canadian postal code format: Letter-Number-Letter-Number-Letter-Number
            const canadianZipCodeRegex = /^[A-Z]\d[A-Z]\d[A-Z]\d$/;
            
            // Test if it follows Canadian zip code format
            if (canadianZipCodeRegex.test(cleanedInput)) {
                // Return in proper Canadian format with space after 3 characters
                return cleanedInput.replace(/^(.{3})(.{3})$/, '$1 $2');
            }
            
            // Return as-is if it doesn't match Canadian format
            return input;
        } catch (error) {
            console.warn('Error formatting zip code:', error);
            return input;
        }
    }

    calculateShortFormCount() {
        const sections = document.querySelectorAll('.aside-card.tabs .tabs-wrapper');
        // Loop through each section
        sections?.forEach((section, sectionIndex) => {
            const labels = section.querySelectorAll('label');
            const uls = section.querySelectorAll('ul.req-call-tabs');

            if(section.querySelectorAll('.lead-service-type,.short-lead-service-type').length > 0){
                section.querySelector('ul.req-call-tabs')?.remove();
                const uniqueName = `short-request-call-${sectionIndex + 1}`;
                const inputs = section.querySelectorAll('.lead-service-type,.short-lead-service-type');
                inputs?.forEach((input) => {
                    (input as HTMLInputElement).name = `${uniqueName}`;
                    input.id = `${input.id}-${sectionIndex + 1}`;
                });
            }

            uls?.forEach((ul) => {
                const uniqueName = `short-request-call-${sectionIndex + 1}`;
                const inputs = ul.querySelectorAll('input');
                inputs?.forEach((input) => {
                    // Assign the same name to inputs within the same ul
                    input.name = `${uniqueName}`;
                    input.id = `${input.id}-${sectionIndex + 1}`;
                });
            });

            labels?.forEach((label) => {
                if (label.htmlFor) {
                    const label1 = `short-form-${label.htmlFor}-${sectionIndex + 1}`;
                    label.htmlFor = label1;
                }
            });
        });

        const commonSelector = '.req-call-tablist .req-call-radio';
        const radioButtons = document.querySelectorAll(commonSelector);
        radioButtons?.forEach(element => {
            const radioButton = element as HTMLInputElement;
            // To ensure the radio button is checked
            if (radioButton.hasAttribute('checked') || radioButton.checked) {
                radioButton.checked = true;
            }
        });
    }
}

const residentialForm = new ResidentialForm();